export enum WorkflowKey {
  SEEDING = 'seeding',
  SEEDING_SOY = 'seedingSoy',
  FERTILIZATION = 'fertilization',
  FERTILIZATION_CEREALS = 'fertilizationCereals',
  SPRAYING = 'spraying',
}
export enum WorkflowKeyForRoutes {
  SEEDING = 'seeding',
  SEEDING_SOY = 'seeding-soy',
  FERTILIZATION = 'fertilization',
  FERTILIZATION_CEREALS = 'fertilization-cereals',
  SPRAYING = 'spraying',
}
